import apiClient from '../client'

export const websiteService = {
    // Get all website connections with filters and pagination
    getAllWebsites: async (filters = {}, pagination = {}) => {
        const params = new URLSearchParams()
        if (filters.platform) {
            params.append('platform', filters.platform)
        }
        if (filters.isActive !== undefined) {
            params.append('isActive', filters.isActive)
        }
        if (pagination.page) {
            params.append('page', pagination.page)
        }
        if (pagination.limit) {
            params.append('limit', pagination.limit)
        }

        const queryString = params.toString()
        const url = queryString ? `/websites?${queryString}` : '/websites'
        const response = await apiClient.get(url)
        return response.data
    },

    // Get website connection by ID
    getWebsiteById: async (websiteConnectionId) => {
        const response = await apiClient.get(`/websites/${websiteConnectionId}`)
        return response.data
    },

    // Create website connection
    createWebsite: async (websiteData) => {
        const response = await apiClient.post('/websites', websiteData)
        return response.data
    },

    // Update website connection
    updateWebsite: async (websiteConnectionId, websiteData) => {
        const response = await apiClient.put(`/websites/${websiteConnectionId}`, websiteData)
        return response.data
    },

    // Delete website connection
    deleteWebsite: async (websiteConnectionId) => {
        const response = await apiClient.delete(`/websites/${websiteConnectionId}`)
        return response.data
    },

    // Test website connection
    testConnection: async (websiteConnectionId) => {
        const response = await apiClient.post(`/websites/${websiteConnectionId}/test`)
        return response.data
    },

    // Get scans for a website
    getWebsiteScans: async (websiteId, pagination = {}) => {
        const params = new URLSearchParams()
        if (pagination.page) params.append('page', pagination.page)
        if (pagination.limit) params.append('limit', pagination.limit)
        const queryString = params.toString()
        const url = queryString
            ? `/accessibility/websites/${websiteId}/scans?${queryString}`
            : `/accessibility/websites/${websiteId}/scans`
        const response = await apiClient.get(url)
        return response.data
    },
}
